import {
  PatientPickerList as PatientPickerListView,
  useLinkableContextItems,
  type PatientPickerListProps,
} from '@heidi/agents';

/** Binds the patient picker to the app's linkable-context rows. */
export const PatientPickerList = (props: PatientPickerListProps): JSX.Element => (
  <PatientPickerListView {...props} useLinkableItems={useLinkableContextItems} />
);
